import { render } from "./SalesCart.vue?vue&type=template&id=fbe80422"
import script from "./SalesCart.vue?vue&type=script&lang=js"
export * from "./SalesCart.vue?vue&type=script&lang=js"

import "./SalesCart.vue?vue&type=style&index=0&id=fbe80422&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__